import React, { useCallback } from "react";

import StyleGuideFileUpload from "@arachnys/styleguide/FileUpload";
import { obtainAccessToken } from "../../api/apollo";

const FileUpload = ({ beforeUpload, ...rest }) => {
    const beforeUploadAccess = useCallback(
        async (...args) => {
            await obtainAccessToken();
            return typeof beforeUpload === "function"
                ? beforeUpload(...args)
                : undefined;
        },
        [beforeUpload]
    );

    return <StyleGuideFileUpload {...rest} beforeUpload={beforeUploadAccess} />;
};

export default FileUpload;
